//平台类型
export const getClient = () => {
    let u = navigator.userAgent
    let clientType = ''
    if (/(iPhone|iPad|iPod|iOS)/i.test(u)) {
        clientType = "typeIos";
    } else if (/(Android)/i.test(u)) {
        clientType = "typeAndroid";
    } else {
        clientType = "typePC";
    }
    return clientType
}

//JS调用Android方法：接收Android传递过来的数据，并做处理
export const hanldAndroidVote = () => {
    window.android.submit();
    //参数一：调用java中的方法   submitFromWeb是方法名，必须和Android中注册时候的方法名称保持一致
    //参数二：返回给Android端的数据，可以为字符串，json等信息
    //参数三：js接收到Android传递过来的数据之后的相应处理逻辑
    // window.WebViewJavascriptBridge.callHandler(
    //     "submit",
    //     { param: "Android你好，我点击了投票按钮" },
    //     function (responseData) {
    //         // alert("JS接收到Android数据弹JS对话框：" + responseData);
    //     }
    // );

    // let hanldVoteTxt = '点击了安卓投票按钮'
    // return hanldVoteTxt
}

// var fromAndroidpara = {}

// //自定义JS注册事件监听 connectWebViewJavascriptBridge 方法名可改
// export const connectWebViewJavascriptBridge = function (callback) {
//     // fromAndroidpara = { status: "2" }
//     console.log("自定义JS注册事件监听 connectWebViewJavascriptBridge 方法")
//     if (window.WebViewJavascriptBridge) {
//         callback(WebViewJavascriptBridge);
//     } else {
//         document.addEventListener(
//             "WebViewJavascriptBridgeReady",
//             function () {
//                 callback(WebViewJavascriptBridge);
//             },
//             false
//         );
//     }
// }

// //注册回调函数，第一次连接时调用 初始化函数 connectWebViewJavascriptBridge和上面一致
// connectWebViewJavascriptBridge(function (bridge) {
//     fromAndroidpara = { status: "2" }
//     alert("改个按钮状态啊~~")
//     //初始化 必须有 Android 通过 JSBridge 调用 默认JS bridge.init bridgeWebView.send调用
//     bridge.init(function (message, responseCallback) {
//         var data = {
//             "Javascript Responds": "Android调用JS初始化方法!",
//         };
//         responseCallback(data);
//     });

//     //Android调用js方法：functionInJs方法名称需要保持一致 ，并返回给Android通知
//     bridge.registerHandler("fromAndroid", function (data, responseCallback) {
//         alert("JS接收到Android数据弹JS对话框：" + data);
//         //希望data格式是：{ status: "3" }，//1可投 ， 2 已投 ， 3 过期
//         fromAndroidpara = data;
//         var data2 = "";
//         var responseData = data2;
//         responseCallback(responseData);
//     });
// });


// export const fromAndroidStatus = () => {
//     return fromAndroidpara
// }




